import moment from "moment";
// import TableProfile from "../../../../components/Common/TableProfile";

export const getColum = (body, payOutHandler) => [
  {
    label: "Sr no",
    id: "srNo",
    isComponent: true,
    component: (_, key) => (
      <p className={` m-0`}>{(body.page - 1) * body.limit + (key + 1)}</p>
    ),
  },
  // { label: "Driver Name", id: "driverName", classNames: "themeBlue fw-sbold" },
  {
    label: "Driver Name",
    isComponent: true,
    id: "driverName",
    component: (item, key) => (
      // <TableProfile url={item.customerImage} name={item.customerName} />
      <p className={` fw-sbold m-0`}>{item?.driverDetails?.name} </p>
    ),
  },
  { label: "Booking Id", id: "bookingNumber", classNames: " fw-sbold" },
  // { label: "Phone Number", id: "phoneNumber", classNames: " fw-sbold" },
  {
    label: "Phone Number",
    isComponent: true,
    id: "phoneNumber",
    component: (item, key) => (
      <p className={` fw-sbold m-0`}>{item?.driverDetails?.mobileNumber} </p>
    ),
  },
  {
    label: "Booking Date",
    id: "bookingDate",
    isComponent: true,
    component: (item) => (
      <p className={` fw-sbold m-0`}>
        {moment(item.createdAt).format("MM/DD/YYYY")}
      </p>
    ),
  },
  {
    label: "Delivery Fee",
    id: "agencyDriverComission",
    classNames: "fw-sbold text-danger",
    isComponent: true,
    component: (item) => (
      <p className={` fw-sbold m-0`}>
        ${item?.agencyDriverComission}
      </p>
    ),
  },
  {
    label: "Payout",
    id: "",
    isComponent: true,
    component: (item, key) => (
      <button
        className={`actnBtn commonBtn h-auto btn text-white  `}
        style={{
          background: item.isPayout && "green",
          border: "green",
        }}
        onClick={() => !item.isPayout && payOutHandler(item)}
      >
        {item?.isPayout ? "Paid" : "Payout"}
      </button>
    ),
  },
];
